"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGalleryGroupedRows = exports.getVisibleRowIds = exports.getPureLinearRows = exports.getLinearRowsIndexMap = exports.getLinearRows = exports.getSearchResult = exports.getGroupBreakpoint = exports.getKanbanGroup = exports.getKanbanGroupMap = exports.getVisibleRowsIndexMap = exports.getVisibleRows = exports.getVisibleRowsWithoutSearch = exports.getRecordMoveType = exports.getRowsIndexMap = exports.getViewDerivatePrepared = exports.getViewDerivation = exports.EMPTY_DERATION = exports.findRealField = exports.getPureVisibleRowsIndexMap = exports.getPureVisibleRows = exports.getGroupFields = exports.getQueryFilterInfo = exports.getFilterInfo = exports.sortRowsBySortInfo = void 0;
const i18n_1 = require("../../../../../../exports/i18n");
const interfaces_1 = require("../../../../../../exports/store/interfaces");
const model_1 = require("../../../../../../model");
const constants_1 = require("../../../../../../modules/shared/store/constants");
const re_reselect_1 = __importDefault(require("re-reselect"));
const reselect_1 = require("reselect");
const types_1 = require("../../../../../../types");
const mirror_1 = require("../mirror");
const base_1 = require("./base");
const cell_calc_1 = require("./cell_calc");
/**
 * Single Sort Calculation.
 */
function sortRowsBySortInfo(state, rows, sortRules, snapshot) {
    const shallowRows = [...rows];
    shallowRows.sort((prev, current) => {
        return sortRules.reduce((acc, rule) => {
            const field = snapshot.meta.fieldMap[rule.fieldId];
            // TODO: temp code online, when merge to develop, delete this
            if (!field || acc !== 0) {
                return acc;
            }
            const fieldMethod = model_1.Field.bindContext(field, state);
            // same as filter, sort remove the check of column permission
            const cv1 = (0, cell_calc_1.getCellValue)(state, snapshot, prev.recordId, field.id, undefined, undefined, true);
            const cv2 = (0, cell_calc_1.getCellValue)(state, snapshot, current.recordId, field.id, undefined, undefined, true);
            const res = fieldMethod.compare(cv1, cv2, true);
            const sign = rule.desc ? -1 : 1;
            return res * sign;
        }, 0);
    });
    return shallowRows;
}
exports.sortRowsBySortInfo = sortRowsBySortInfo;
exports.getFilterInfo = (0, re_reselect_1.default)([base_1.getSnapshot, base_1.getActiveViewId, state => (0, mirror_1.getMirror)(state)], (snapshot, viewId, mirror) => {
    var _a, _b;
    if (!snapshot || !viewId) {
        return;
    }
    const view = (0, base_1.getViewById)(snapshot, viewId);
    if (!view) {
        return;
    }
    if (mirror === null || mirror === void 0 ? void 0 : mirror.id) {
        const originViewConditionIds = ((_a = view.filterInfo) === null || _a === void 0 ? void 0 : _a.conditions.map(item => item.conditionId)) || [];
        const filterInfo = (_b = mirror.temporaryView) === null || _b === void 0 ? void 0 : _b.filterInfo;
        const mirrorConditions = filterInfo === null || filterInfo === void 0 ? void 0 : filterInfo.conditions.filter(item => {
            return !originViewConditionIds.includes(item.conditionId) && !item.isQuery;
        });
        if (!mirrorConditions) {
            return filterInfo;
        }
        return {
            conjunction: filterInfo.conjunction,
            conditions: mirrorConditions,
        };
    }
    // if(view.filterInfo){
    //    return {
    //     conjunction: view.filterInfo!.conjunction,
    //     conditions: view.filterInfo.conditions.filter(item => {!item.isQuery})
    //   };
    // }
    return view.filterInfo;
})({
    keySelector: (state, datasheetId) => state.pageParams.mirrorId || datasheetId || (0, base_1.getActiveDatasheetId)(state),
});
exports.getQueryFilterInfo = (0, re_reselect_1.default)([base_1.getSnapshot, base_1.getActiveViewId, state => (0, mirror_1.getMirror)(state)], (snapshot, viewId, mirror) => {
    var _a;
    if (!snapshot || !viewId) {
        return;
    }
    const view = (0, base_1.getViewById)(snapshot, viewId);
    if (!view) {
        return;
    }
    if (mirror === null || mirror === void 0 ? void 0 : mirror.id) {
        //const originViewConditionIds = view.filterInfo?.conditions.map(item => item.conditionId) || [];
        const filterInfo = (_a = mirror.temporaryView) === null || _a === void 0 ? void 0 : _a.queryFilterInfo;
        return filterInfo;
    }
    return;
})({
    keySelector: (state, datasheetId) => state.pageParams.mirrorId || datasheetId || (0, base_1.getActiveDatasheetId)(state),
});
/* clipboard for clipboard */
const getGroupFields = (view, fieldMap, fieldPermissionMap) => {
    const fields = [];
    view.groupInfo && view.groupInfo.forEach(gp => {
        const fieldRole = (0, base_1.getFieldRoleByFieldId)(fieldPermissionMap, gp.fieldId);
        if (fieldRole === interfaces_1.Role.None) {
            fields.push({
                id: gp.fieldId,
                type: types_1.FieldType.NotSupport,
                name: (0, i18n_1.t)(i18n_1.Strings.crypto_field),
                property: null,
            });
            return;
        }
        const field = fieldMap[gp.fieldId];
        if (field) {
            fields.push(field);
        }
        else {
            console.warn('! can\'t find group field %s on datasheet', gp.fieldId);
        }
    });
    return fields;
};
exports.getGroupFields = getGroupFields;
const getPureVisibleRows = (state, datasheetId) => {
    return (0, exports.getViewDerivation)(state, datasheetId).pureVisibleRows;
};
exports.getPureVisibleRows = getPureVisibleRows;
const getPureVisibleRowsIndexMap = (state, datasheetId) => {
    return (0, exports.getViewDerivation)(state, datasheetId).pureVisibleRowsIndexMap;
};
exports.getPureVisibleRowsIndexMap = getPureVisibleRowsIndexMap;
const findRealField = (state, propsField) => {
    if (propsField.type !== types_1.FieldType.LookUp) {
        return propsField;
    }
    return model_1.Field.bindContext(propsField, state).getLookUpEntityField();
};
exports.findRealField = findRealField;
exports.EMPTY_DERATION = {
    linearRows: [],
    visibleRows: [],
    visibleRowsIndexMap: new Map(),
    pureLinearRows: [],
    linearRowsIndexMap: new Map(),
    rowsWithoutSearch: [],
    rowsIndexMap: new Map(),
    pureVisibleRows: [],
    pureVisibleRowsIndexMap: new Map(),
    kanbanGroupMap: {}
};
const getViewDerivation = (state, datasheetId, viewId) => {
    var _a, _b;
    let _datasheetId = datasheetId || (0, base_1.getActiveDatasheetId)(state);
    if (!datasheetId && state.datasheetMap[constants_1.PREVIEW_DATASHEET_ID]) {
        _datasheetId = constants_1.PREVIEW_DATASHEET_ID;
    }
    let _viewId = viewId || (0, base_1.getActiveViewId)(state, _datasheetId);
    _viewId = (0, base_1.getViewIdByNodeId)(state, _datasheetId, _viewId);
    const derivation = ((_b = (_a = state.datasheetMap[_datasheetId]) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.viewDerivation[_viewId]) || exports.EMPTY_DERATION;
    return derivation;
};
exports.getViewDerivation = getViewDerivation;
const getViewDerivatePrepared = (state, datasheetId, viewId) => {
    var _a, _b;
    const _datasheetId = datasheetId || (0, base_1.getActiveDatasheetId)(state);
    const _viewId = viewId || (0, base_1.getActiveViewId)(state);
    const nodeViewId = (0, base_1.getViewIdByNodeId)(state, _datasheetId, _viewId);
    return Boolean((_b = (_a = state.datasheetMap[_datasheetId]) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.viewDerivation[nodeViewId]);
};
exports.getViewDerivatePrepared = getViewDerivatePrepared;
const getRowsIndexMap = (state, datasheetId) => {
    return (0, exports.getViewDerivation)(state, datasheetId).rowsIndexMap;
};
exports.getRowsIndexMap = getRowsIndexMap;
const getRecordMoveType = (state) => {
    return (0, exports.getViewDerivation)(state).recordMoveType || constants_1.RecordMoveType.NotMove;
};
exports.getRecordMoveType = getRecordMoveType;
const getVisibleRowsWithoutSearch = (state, datasheetId, viewId) => {
    return (0, exports.getViewDerivation)(state, datasheetId, viewId).rowsWithoutSearch;
};
exports.getVisibleRowsWithoutSearch = getVisibleRowsWithoutSearch;
const getVisibleRows = (state) => {
    return (0, exports.getViewDerivation)(state).visibleRows;
};
exports.getVisibleRows = getVisibleRows;
const getVisibleRowsIndexMap = (state) => {
    return (0, exports.getViewDerivation)(state).visibleRowsIndexMap;
};
exports.getVisibleRowsIndexMap = getVisibleRowsIndexMap;
const getKanbanGroupMap = (state) => {
    return (0, exports.getViewDerivation)(state).kanbanGroupMap;
};
exports.getKanbanGroupMap = getKanbanGroupMap;
const getKanbanGroup = (kanbanGroupMap, groupId) => {
    return kanbanGroupMap[groupId] || [];
};
exports.getKanbanGroup = getKanbanGroup;
const getGroupBreakpoint = (state) => {
    return (0, exports.getViewDerivation)(state).groupBreakpoint;
};
exports.getGroupBreakpoint = getGroupBreakpoint;
// Get the search result set
const getSearchResult = (state) => {
    return (0, exports.getViewDerivation)(state).searchResults;
};
exports.getSearchResult = getSearchResult;
/**
 * Instructs the react-window to draw structured data for the table, with the hierarchy reflected by depth.
 * [
 *    Blank 0
 *    GroupTab 0
 *      GroupTab 1
 *        GroupTab 2
 *          Record 3
 *        Add 2
 *        Blank 2
 *      Blank 1
 *    Blank 0
 * ]
 */
const getLinearRows = (state) => {
    return (0, exports.getViewDerivation)(state).linearRows;
};
exports.getLinearRows = getLinearRows;
const getLinearRowsIndexMap = (state) => {
    return (0, exports.getViewDerivation)(state).linearRowsIndexMap;
};
exports.getLinearRowsIndexMap = getLinearRowsIndexMap;
const getPureLinearRows = (state) => {
    return (0, exports.getViewDerivation)(state).pureLinearRows;
};
exports.getPureLinearRows = getPureLinearRows;
exports.getVisibleRowIds = (0, reselect_1.createSelector)([exports.getVisibleRows], (visibleRows) => {
    return visibleRows.map(row => row.recordId);
});
const getGalleryGroupedRows = (state) => {
    return (0, exports.getViewDerivation)(state).galleryGroupedRows;
};
exports.getGalleryGroupedRows = getGalleryGroupedRows;
//# sourceMappingURL=rows_calc.js.map